import { OrderStatus } from 'types/shared';

export const orderStatusLabelMap = {
  [OrderStatus.COMPLETED]: 'Completed',
  [OrderStatus.PENDING]: 'Pending',
  [OrderStatus.CANCELLED]: 'Cancelled',
} as const;

export const ORDERS_COUNT_PER_PAGE = 30;
